import { dropBoolean, dropModeloSerie } from 'utils/drops';

const getSerieFilterFields = (drops = {}) => [
  {
    name: 'id',
    label: 'ID',
    type: 'number',
  },
  {
    name: 'serie',
    label: 'Série',
  },
  {
    name: 'descricao',
    label: 'Descrição',
    initial: true,
  },
  {
    name: 'ativo',
    label: 'Ativo',
    type: 'select',
    options: dropBoolean,
  },
  {
    name: 'filial',
    label: 'Filial',
    type: 'select',
    options: drops?.Filial,
    multiple: true,
  },
  {
    name: 'modelo',
    label: 'Modelo',
    type: 'select',
    options: dropModeloSerie,
    multiple: true,
  },
  {
    name: 'modelofiscal',
    label: 'Modelo Fiscal',
    type: 'select',
    options: drops?.Modelofiscal,
    multiple: true,
  },
];

export default getSerieFilterFields;
